module.exports = __webpack_public_path__ + "img/x-close.e48383ce.svg";